import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { appVariables } from '../app.constants';

@Injectable()
export class referrerPolicyInterceptor implements HttpInterceptor {

  public constructor() {
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const referrerPolicy = req.headers.get('Referrer-Policy');
    // let clonedRequest: HttpRequest<any>;

    // Clone the request and set the new header.
    if (referrerPolicy) {
      req = req.clone({headers: req.headers.set('Referrer-Policy', referrerPolicy)});
      // clonedRequest = req.clone({
      //   setHeaders: {client_id: clientId, client_secret: clientSecret, 'Referrer-Policy': referrerPolicy}
      // });
    } else {
      req = req.clone({headers: req.headers.set('Referrer-Policy', appVariables.defaultreferrerPolicyHeader)});
    }

    // send cloned request with header to the next handler.
    return next.handle(req);
  }
}
